import { Component,OnInit  } from '@angular/core';
import {  UsuarioService } from '../../servicios/usuario.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from "../../servicios/alert.service";

@Component({
    selector: 'login',
    templateUrl: 'login.template.html'
})
export class loginComponent implements OnInit {

    model: any = {};
    loading = false;
    returnUrl: string;
 
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: UsuarioService,
        private alertService: AlertService
    ) {  }

    getCookies(){
        this.authenticationService.init()
        .subscribe(
            data => {
                let res = data;
                console.log(res);
                
            },
            error => {
                this.alertService.error("Error Al conectar con el servidor");
                console.log("errorrr");
                this.loading = false;
            });
    }
 
    ngOnInit() {
        // reset login status
        this.authenticationService.logout();
 
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        this.getCookies();
    }
 
    login() {
        this.loading = true;
        this.authenticationService.login(this.model.username, this.model.password)
        .subscribe(
            data => {
                let res = data;
                console.log(res);
                if (res.message == "Correcto") {
                   localStorage.setItem("user",res.request);
                   this.router.navigate(['conductores']);
                    
                } else {
                    console.log(res.request);
                    this.alertService.error(res.request);
                    this.loading = false;
                }
                
            },
            error => {
                this.alertService.error("Error Al conectar con el servidor");
                console.log("errorrr");
                this.loading = false;
            });
           
    }

 }


// WEBPACK FOOTER //
// ./src/app/views/login/login.component.ts